var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg145Upload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.244,156.04L240.898,45.817C244.671,42.065,249.677,40,255,40c5.342,0,10.364,2.081,14.169,5.886L379.886,156.17 c3.903,3.888,9.008,5.831,14.114,5.83c5.131,0,10.263-1.963,14.17-5.886c7.795-7.826,7.771-20.489-0.056-28.284L297.426,17.574 C286.094,6.241,271.026,0,255,0s-31.094,6.241-42.426,17.574c-0.034,0.034-0.067,0.068-0.101,0.102L103.757,127.959 c-7.754,7.866-7.664,20.529,0.203,28.284C111.826,163.997,124.49,163.907,132.244,156.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,120v245c0,11.046,8.954,20,20,20s20-8.954,20-20V120c0-11.046-8.954-20-20-20C244.954,100,236,108.954,236,120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492,412c-11.046,0-20,8.954-20,20c0,22.056-17.944,40-40,40H80c-22.056,0-40-17.944-40-40c0-11.046-8.954-20-20-20 s-20,8.954-20,20c0,44.112,35.888,80,80,80h352c44.112,0,80-35.888,80-80C512,420.954,503.046,412,492,412z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg145Upload);
export default __webpack_public_path__ + "static/media/145-upload.8da3fb4e312faf1ac8975ba68596f55d.svg";
export { ForwardRef as ReactComponent };